import React, { useState } from "react";
import { api } from "@/lib/api";
import { UploadCloud, Loader2, File as FileIcon, X } from "lucide-react";
import { toast } from "sonner";

// onUploaded receives {id, storage_path, original_filename, content_type}
export default function FileUploader({ label = "Upload file", accept, onUploaded, testid, multiple = false }) {
  const [busy, setBusy] = useState(false);
  const [items, setItems] = useState([]);

  const handle = async (e) => {
    const files = Array.from(e.target.files || []);
    if (!files.length) return;
    setBusy(true);
    try {
      for (const f of files) {
        const fd = new FormData();
        fd.append("file", f);
        const { data } = await api.post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
        setItems((p) => [...p, data]);
        onUploaded && onUploaded(data);
      }
      toast.success("File uploaded");
    } catch (err) {
      toast.error("Upload failed");
    } finally {
      setBusy(false);
      e.target.value = "";
    }
  };

  return (
    <div>
      <label
        data-testid={testid}
        className="flex flex-col items-center justify-center gap-2 border-2 border-dashed border-slate-300 rounded-xl p-6 cursor-pointer hover:border-sunburst hover:bg-orange-50/40 transition-colors"
      >
        {busy ? (
          <Loader2 className="w-6 h-6 text-sunburst animate-spin" />
        ) : (
          <UploadCloud className="w-6 h-6 text-slate-400" />
        )}
        <span className="text-sm font-medium text-slate-500">{busy ? "Uploading…" : label}</span>
        <input type="file" className="hidden" accept={accept} multiple={multiple} onChange={handle} disabled={busy} />
      </label>
      {items.length > 0 && (
        <div className="mt-3 space-y-2">
          {items.map((it, i) => (
            <div key={i} className="flex items-center gap-2 text-sm bg-slate-50 rounded-lg px-3 py-2">
              <FileIcon className="w-4 h-4 text-slate-400" />
              <span className="truncate flex-1 text-slate-600">{it.original_filename}</span>
              <X className="w-4 h-4 text-slate-300 cursor-pointer hover:text-red-500"
                 onClick={() => setItems((p) => p.filter((_, idx) => idx !== i))} />
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
